import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { cn } from "@/lib/utils";

export function BrandLogo({ variant = "emblem", className, testId, decorative = false }) {
  const reduce = useReducedMotion();
  return (
    <motion.span className={cn("brand-logo inline-flex shrink-0", className)} whileHover={reduce ? undefined : { scale: 1.04, y: -1 }} transition={{ duration: 0.25 }}>
      <img src={variant === "lockup" ? "/nyayyaksha-lockup-hd.webp" : "/nyayyaksha-emblem-hd.webp"} alt={decorative ? "" : "Nyayyaksha — न्यायः परमः धर्मः"} className="h-full w-full object-contain" data-testid={testId} draggable="false" />
    </motion.span>
  );
}

export function BrandIntroduction() {
  const reduce = useReducedMotion();
  return (
    <div className="brand-introduction" data-testid="brand-introduction">
      <div className="brand-orbit brand-orbit-outer" aria-hidden="true" />
      <div className="brand-orbit brand-orbit-inner" aria-hidden="true" />
      <motion.div className="brand-hero-art" initial={reduce ? false : { opacity: 0, rotateY: -24, y: 24, scale: 0.9 }} animate={{ opacity: 1, rotateY: 0, y: 0, scale: 1 }} transition={{ type: "spring", stiffness: 65, damping: 18, delay: 0.12 }}>
        <BrandLogo variant="lockup" className="brand-hero-lockup" testId="login-hero-logo" decorative />
      </motion.div>
      <span className="brand-reveal-rule" aria-hidden="true" />
    </div>
  );
}

export function BrandLoader({ message = "Loading your workspace…", testId = "workspace-loader" }) {
  return (
    <div className="brand-loading flex min-h-screen flex-col items-center justify-center gap-6 bg-paper" role="status" aria-live="polite" data-testid={testId}>
      <div className="brand-loading-seal"><BrandLogo className="h-28 w-28" testId={`${testId}-logo`} /></div>
      <div className="text-center"><div className="font-display text-2xl font-semibold tracking-[0.12em] text-ink">NYAYYAKSHA</div><p className="mt-2 text-sm text-ink-2" data-testid={`${testId}-message`}>{message}</p></div>
      <span className="brand-loading-line" aria-hidden="true" />
    </div>
  );
}
